module.exports = __webpack_public_path__ + "img/intro_phone2.9db6a27d.png";